import { MediaFileTypes } from 'application/pages/types';

export const MEDIA_FILE_TYPE = MediaFileTypes.PROMO;

export const ELEMENT_IDS = {
  uploadButton: 'button_ad_campaign_stepper_media_upload',
  uploadInputTestId: 'input_ad_campaign_stepper_media_upload',
  mediaIconsPrefix: 'ad_campaign_stepper_media',
  timeInputPrefix: 'input_ad_campaign_stepper_media_time',
  dragHandlePrefix: 'drag-handle_ad_campaign_stepper_media_exact_time',
} as const;
